import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { whatWeDo } from "@/mocks/aboutData";

export default function WhatWeDoSection() {
  return (
    <section className="bg-tie-grey-light py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-5">
                <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                  / What We Do
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-5xl font-bold text-tie-text-primary leading-tight">
                Six Capabilities. One Ecosystem.
              </h2>
              <p className="mt-3 md:mt-4 text-base md:text-lg text-tie-text-secondary">
                TIE is not a single service - it is an integrated operating system
                that covers the full lifecycle of textile innovation.
              </p>
            </div>
          </ScrollReveal>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {whatWeDo.map((item, index) => (
              <ScrollReveal key={item.title} delay={index * 100}>
                <div className="group h-full p-5 md:p-6 rounded-xl bg-white border border-tie-grey-dark hover:border-tie-teal/30 hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
                  <div className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-tie-teal/10 flex items-center justify-center mb-4 md:mb-5 group-hover:bg-tie-teal group-hover:text-white transition-all duration-300">
                    <i className={`${item.icon} text-tie-teal text-lg md:text-xl group-hover:text-white transition-colors`} />
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-tie-text-primary mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-tie-text-secondary leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}